import { apiBuilder } from "@zodios/core";
import { z } from "zod";
import { userProfileSchema } from "./userProfile";

export const registrationApiDefinitions = apiBuilder({
  method: "post",
  path: "/api/signup/",
  alias: "signupUser",
  parameters: [
    {
      name: "body",
      type: "Body",
      schema: z.object({
        first_name: z.string(),
        last_name: z.string(),
        email: z.string().email(),
        password: z.string(),
      }),
    },
  ],
  response: z.unknown(),
})
  .addEndpoint({
    method: "post",
    path: "/api/registerorganization/",
    alias: "registerOrganization",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: z.object({
          user_email: z.string().email(),
          organization_name: z.string(),
          referral_token: z.string().optional(),
          affiliate_token: z.string().optional(),
          country: z.string().optional(),
          specified_user_email: z.string().email(),
          contact_number: z.string(),
          hear_about_us: z.string().nullable(),
          terms_agreement: z.boolean(),
          bypass_onboarding: z.string().nullable(),
        }),
      },
    ],
    response: z.unknown(),
  })
  .addEndpoint({
    method: "post",
    path: "/api/authentication/?custom_api_request=login_user_info",
    alias: "fetchLoginUserInfo",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: z.object({
          custom_api_request: z.literal("login_user_info"),
          user_email: z.string().email(),
        }),
      },
    ],
    response: userProfileSchema,
  })
  .addEndpoint({
    method: "post",
    path: "/api/authentication/?custom_api_request=user_login_verification",
    alias: "fetchLoginUserVerification",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: z.object({
          custom_api_request: z.literal("user_login_verification"),
          user_email: z.string().email(),
        }),
      },
    ],
    response: z.string(),
  })
  .addEndpoint({
    method: "post",
    path: "/api/reset-password/",
    alias: "requestPasswordReset",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: z.object({
          email: z.string().email(),
        }),
      },
    ],
    response: z.unknown(),
  })
  .addEndpoint({
    method: "post",
    path: "/api/new-password/",
    alias: "processPasswordReset",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: z.object({
          token: z.string(),
          newPassword: z.string(),
        }),
      },
    ],
    response: z.unknown(),
  })
  .addEndpoint({
    method: "post",
    path: "auth/convert-token",
    alias: "convertTokens",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: z.object({
          grant_type: z.literal("convert_token"),
          backend: z.string(),
          client_id: z.string(),
          client_secret: z.string(),
          token: z.string(),
        }),
      },
    ],
    response: z.object({
      access_token: z.string(),
      refresh_token: z.string(),
    }),
  })
  .addEndpoint({
    method: "post",
    path: "/auth/token",
    alias: "login",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: z.object({
          client_id: z.string(),
          client_secret: z.string(),
          grant_type: z.literal("password"),
          username: z.string().email(),
          password: z.string(),
        }),
      },
    ],
    response: z.object({
      access_token: z.string(),
      refresh_token: z.string(),
    }),
  })
  .addEndpoint({
    method: "post",
    path: "/auth/passinvite",
    alias: "acceptUserInvitation",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: z.object({
          client_id: z.string(),
          client_secret: z.string(),
          grant_type: z.literal("password"),
          first_name: z.string(),
          last_name: z.string(),
          password: z.string(),
          inviteToken: z.string(),
        }),
      },
    ],
    response: z.object({
      status: z.string(),
      email_address: z.string(),
    }),
  })
  .build();
